import React, { useMemo } from 'react';
import { useLanguage } from '../components/LanguageContext';
import { useProfileState } from '../components/ProfileStateContext';
import { TOPICS } from '../data/topics';
import { TopicCard } from '../components/TopicCard';
import { TopicImageCard } from '../components/TopicImageCard';
interface Props {
  onSelectTopic: (topicId: string) => void;
}
export function MatchPeople({
  onSelectTopic
}: Props) {
  const {
    t
  } = useLanguage();
  const {
    selectedThemeIds
  } = useProfileState();
  const {
    yourInterests,
    otherTopics
  } = useMemo(() => {
    const idSet = new Set(selectedThemeIds);
    const yourInterests = TOPICS.filter(tp => idSet.has(tp.id));
    const otherTopics = TOPICS.filter(tp => !idSet.has(tp.id));
    return {
      yourInterests,
      otherTopics
    };
  }, [selectedThemeIds]);
  return <div className="flex flex-col h-full w-full bg-[#0D0D0D] overflow-y-auto" data-id="element-471">
      <div className="w-full px-5 py-4 flex flex-col gap-3 pl-[16px] pr-[16px]" data-id="element-472">
        
        {otherTopics.map(topic => <div key={topic.id} className="rounded-[4px] overflow-hidden" data-id="element-473">
            <TopicImageCard topic={topic} onSelect={onSelectTopic} data-id="element-474" />
          </div>)}
      </div>
    </div>;
}